import { render, staticRenderFns } from "./DragAndDropCloneList.vue?vue&type=template&id=58fd38e8"
import script from "./DragAndDropCloneList.vue?vue&type=script&lang=js"
export * from "./DragAndDropCloneList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports